// extracted by mini-css-extract-plugin
export default {"send-button":"ProxieSuggestionForm_send-button__5uKKU","reset-button":"ProxieSuggestionForm_reset-button__oElEm"};